<template>
  <div class="va-tree-category">
    <div class="va-tree-category__header" @click="toggle">
      <div class="va-tree-category__header-switcher">
        <va-icon
          v-if="hasChildren"
          :class="`va-icon fa fa-${isOpenCached ? 'minus' : 'plus'}-square-o`"
          :color="$themes.primary"
        />
        <img :src="nodeItem.icon" :style="{ width: '20px' }" alt />
      </div>
      <div class="va-tree-category__header-checkbox" v-if="$slots.checkbox">
        <slot name="checkbox" />
      </div>
      <div class="va-tree-category__header-icon" v-if="icon">
        <va-icon :name="icon" :color="$themes['info']" />
      </div>
      <div class="display-3" :class="{ hasChildren: hasChildren, }">
        {{ nodeItem.name }}
        <spring-spinner
          v-if="isLoading"
          class="loading"
          :animation-duration="1000"
          :size="8"
          :style="{ display: 'inline-block' }"
          :color="$themes.primary"
        />
        <va-button
          @click="moreDetailsOpen = !moreDetailsOpen"
        >{{ moreDetailsOpen ? $t('categories.moreDetailsClose') : $t('categories.moreDetailsOpen') }}</va-button>
      </div>
    </div>

    <div class="va-tree-category__list-container" v-if="isOpenCached">
      <div class="va-tree-category__list-internal-container">
        <single v-if="moreDetailsOpen" :currentId="nodeItem.id" />
        <slot />
        <template>
          <tree-category v-for="child in children" :node-item="child" :key="child.id" />
          <va-button
            @click="loadMoreAction"
            color="info"
            v-if="params.hasMore"
          >{{ $t('categories.loadMore') }}</va-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { SpringSpinner } from 'epic-spinners'

import { mapActions } from 'vuex'
import single from '../single.vue'
export default {
  name: 'TreeCategory',
  components: { SpringSpinner, single },

  data() {
    return {
      isOpenCached: false,
      isLoading: true,
      moreDetailsOpen: false,
      params: {
        limit: 5,
        parent: this.nodeItem.id,
        page: 1,
        total: 0,
        hasMore: false,
      },
      queryReq: {
        limit: 5,
        parent: this.nodeItem.id,
        page: 1,
      },
    }
  },
  watch: {
    isOpen: {
      handler(isOpen) {
        this.isOpenCached = isOpen
      },
      immediate: true,
    },
  },
  props: {
    label: {
      type: [String, Number],
      default: '',
    },
    isOpen: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
    nodeItem: {
      type: Object,
    },

  },
  methods: {
    async loadMoreAction() {
      if (this.params.hasMore) {
        this.isLoading = true
        this.queryReq.page++
        await this.get(this.queryReq)
        this.params = this.$store.state.Categories?.itemsParams[this?.nodeItem?.id]

        this.isLoading = false
      }
    },
    /**
     * @public
     */
    collapse() {
      this.isOpenCached = false
      this.$nextTick(() => {
        this.$children.forEach((child) => {
          if (child.$options.name === 'va-tree-category') {
            child.collapse()
          }
        })
      })
    },
    /**
     * @public
     */
    expand() {
      this.isOpenCached = true
      this.$nextTick(() => {
        this.$children.forEach((child) => {
          if (child.$options.name === 'va-tree-category') {
            child.expand()
          }
        })
      })
    },
    async toggle(e) {
      if (!e.target.classList.contains('va-checkbox__input')) {
        this.isOpenCached = !this.isOpenCached

        if (this.moreDetailsOpen) {
          this.isOpenCached = true
        }
      }
      if (this.hasChildren && this.$store.state.Categories.hasItems) {
        this.isLoading = true
        await this.get(this.queryReq)
        this.params = this.$store.state.Categories?.itemsParams[this?.nodeItem?.id]
      }
      this.isLoading = false
    },
    ...mapActions('Categories', ['get', 'getItem']),

  },
  computed: {
    hasChildren() {
      return this.nodeItem.children.length > 0
    },
    children() {
      return this.nodeItem.children
    },
  },
  async mounted() {
    if (!this.hasChildren && this.$store.state.Categories.hasItems) {
      this.isLoading = true
      await this.get({ parent: this.nodeItem.id, limit: 1 })
      this.params = this.$store.state.Categories?.itemsParams[this?.nodeItem?.id]
    }
    this.isLoading = false
  },
}
</script>

<style lang="scss">
// @import "../../vuestic-sass/resources/resources";

.va-tree-category {
  &__header {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &__header-switcher {
    margin-right: 0.5rem;
  }

  &__header-checkbox {
    margin-right: 0.5rem;
    height: 1.5rem;
    width: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .va-checkbox__square {
      width: 1.5rem;
      height: 1.5rem;
      flex: 0 0 1.5rem;
    }
  }

  &__header-icon {
    color: $theme-blue-dark;
    margin-right: 0.5rem;
    font-size: 24px;
    line-height: 24px;
  }

  &__header-label {
    word-wrap: break-word;
    overflow: hidden;
    font-size: 18px;
    font-weight: 600;
  }

  &__list-container {
    margin-top: 0.625rem;
    padding-left: 0.6875rem;
  }

  &__list-internal-container {
    background-image: linear-gradient($gray 33%, rgba(255, 255, 255, 0) 0%);
    background-position: left;
    background-size: 1px 3px;
    background-repeat: repeat-y;
    padding-left: 1.1875rem;
  }

  & + .va-tree-category,
  .va-tree-node + .va-tree-node,
  .va-tree-category + .va-tree-node,
  .va-tree-node + .va-tree-category {
    margin-top: 0.75rem;
  }
}
</style>
